import { useContext, useEffect, useMemo, useState } from "react";

import { ContextApi } from "../../context/contextApi";
import { mockApiData } from "../../services/mockApi/mockApi";
import { getCityFromUf, getUfsAll } from "../../services/apis/ibgeApi";
import { SelectOrRegister } from "../../libs/inputs/selectOrRegister";
import { Checkbox } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { SpotInformation } from "../../components/spotInformation/SpotInformation";
import { createEmptySpotInfo, hydrateSpotInfo, serializeSpotInfo } from "../../libs/spot/spotData";

import styles from "./style.module.scss";

export function EditDadosPrincipais({ idCam }) {
  const {
    getCameraForId,
    cameraId,
    allRegions,
    getRegions,
    allCameras,
    allEstadosOrdering,
    updateCamera,
    getCameras,
    getAllEstados,
  } = useContext(ContextApi);
  const [nameCamera, setNameCamera] = useState("");
  const [availibility, setAvailability] = useState();
  const [firstReturnRender, setFirstReturnRender] = useState(false);
  const [disponibReturn, setDisponibReturn] = useState([]);
  const [city, setCity] = useState(null);
  const [citySelect, setCitySelect] = useState("");
  const [ufSelect, setUfSelect] = useState("");
  const [ufSiglaSelected, setUfSiglaSelected] = useState("");
  const [selectedRegion, setSelectedRegion] = useState();
  const [establishment, setEstablishment] = useState("");
  const [establishmentLink, setEstablishmentLink] = useState("");
  const [selectPrediction, setSelectPrediction] = useState("");
  const [embedMonuv, setEmbedMonuv] = useState("");
  const [referency, setReferency] = useState("");
  const [description, setDescription] = useState("");
  const [stsPraia, setStsPraia] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [spotInfo, setSpotInfo] = useState(createEmptySpotInfo);
  const countries = useMemo(() => {
    if (allEstadosOrdering.length === 0) {
      return [];
    }
    let arrayCountries = [];
    allEstadosOrdering.forEach((element) => {
      arrayCountries.push({
        id: element.id,
        label: element.estado_sigla,
        description: element.nome,
      });
    });
    return arrayCountries;
  }, [allEstadosOrdering]);
  useEffect(() => {
    getCameraForId(idCam);
    getRegions();
    getCameras();
    getAllEstados();
  }, []);
  useEffect(() => {
    if (cameraId && cameraId?.area_regiao && allCameras?.length > 0) {
      const cameraRef = allCameras?.find((cam) => cam.id === cameraId.id);
      console.log(cameraRef);
      setNameCamera(cameraId?.nome_camera);
      setAvailability(cameraId?.disponibilidade);
      setSelectedRegion({
        idSelected: cameraId?.area_regiao.id,
        regionSelected: cameraId?.area_regiao.nome,
      });
      setUfSiglaSelected(cameraId?.area_regiao?.estado_sigla);
      setEstablishment(cameraId?.parceiro);
      setEstablishmentLink(cameraId?.parceiro_link);
      setSelectPrediction(cameraId?.previsao_metereologica);
      setEmbedMonuv(cameraId?.embeded_monuv);
      setReferency(cameraId?.referencia);
      setDescription(cameraId?.descricao);
      setUfSelect(cameraId?.estado_sigla);
      setStsPraia(cameraRef?.statusPraia);
      setSpotInfo(hydrateSpotInfo(cameraId));
      setLoaded(true);
    }
  }, [cameraId, allCameras]);

  useEffect(() => {
    let idUf;
    if (countries) {
      if (!Number(ufSelect)) {
        idUf = countries?.filter(
          (uf) => uf.description === ufSelect || uf.label === ufSelect
        );
        if (idUf.length === 0) {
          return;
        }
        setUfSiglaSelected(idUf[0].label);
      } else {
        idUf = countries?.filter((uf) => uf.id === Number(ufSelect));
        if (idUf.length === 0) {
          return;
        }
        setUfSiglaSelected(idUf[0].label);
      }
      getCity(idUf[0].id);
    }
  }, [ufSelect, countries]);

  async function handlerSubmitUpdateCam() {
    let ufFilter;
    let cidadeFilter;
    if (citySelect) {
      cidadeFilter = city?.filter((ret) => ret.id === Number(citySelect));
    }
    if (!Number(ufSelect)) {
      ufFilter = countries?.filter((uf) => uf.description === ufSelect);
    } else {
      ufFilter = countries?.filter((retUf) => retUf.id === Number(ufSelect));
    }
    try {
      await updateCamera(idCam, {
      stream_id: cameraId?.stream_id,
      estado_sigla: ufSiglaSelected,
      estado_imagem: "",
      estado: ufFilter[0]?.description
        ? ufFilter[0]?.description
        : cameraId?.estado,
      area_regiao_id: selectedRegion?.idSelected,
      cidade: cidadeFilter
        ? cidadeFilter?.description || cidadeFilter[0]?.description
        : cameraId?.cidade,
      nome_camera: nameCamera,
      parceiro: establishment,
      parceiro_link: establishmentLink,
      stream_hls: "",
      referencia: referency,
      status: true,
      visibilidade: cameraId?.visibilidade,
      digest: "",
      marca_dagua_superior_direito: cameraId?.marca_dagua_superior_direito,
      marca_dagua_superior_esquerdo: cameraId?.marca_dagua_superior_esquerdo,
      poster: cameraId?.poster,
      previsao_metereologica: selectPrediction,
      // previsao_metereologica_resumo: "",
      descricao: description,
      ad_anuncio: cameraId?.ad_anuncio,
      ad_anuncio_single: cameraId?.ad_anuncio_single,
      disponibilidade: availibility,
      embeded_monuv: embedMonuv,
      statusPraia: stsPraia,
      logo: cameraId?.logo,
      ...serializeSpotInfo(spotInfo),
      });
      getCameraForId(idCam);
    } catch {
      // O ContextApi informa a falha e mantém os valores editados na tela.
    }
  }

  async function getCity(id) {
    let idUf;
    if (!Number(id)) {
      idUf = countries?.filter((uf) => uf.description === id);
    }
    let arrayCities = [];
    await getCityFromUf(idUf ? idUf[0].id : id)
      .then((response) =>
        response.data.map((city) => {
          return arrayCities.push({
            id: city.id,
            description: city.nome,
          });
        })
      )
      .catch((err) => console.log(err));
    setCity(arrayCities);
  }

  const Select = ({
    onChange,
    onBlur,
    name,
    label,
    options,
    styleOne,
    value,
    defaultValue,
  }) => {
    return (
      <div
        className={styleOne ? styleOne : styles.inputText}
        onClick={() => {
          setFirstReturnRender(false);
        }}
      >
        <label>{label}</label>
        <select name={name} value={value} onChange={onChange} onBlur={onBlur}>
          <option nome={"Default"}>{defaultValue}</option>

          {options.map((options) => {
            return (
              <option value={options.id ? options.id : options.label}>
                {options.description}
              </option>
            );
          })}
        </select>
      </div>
    );
  };
  if (!loaded) {
    return (
      <div className={styles.loading}>
        <CircularProgress color="inherit" />
      </div>
    );
  }

  return (
    <div className={styles.containerDadosPrincipais}>
      <div className={styles.inputText}>
        <label>Nome da câmera</label>
        <input
          onChange={(e) => setNameCamera(e.target.value)}
          value={nameCamera}
          name="nome_camera"
        />
      </div>
      <Select
        options={firstReturnRender ? disponibReturn : mockApiData.availability}
        label="Disponibilidade"
        value={availibility}
        onChange={(e) => setAvailability(e.target.value)}
      />
      <div className={styles.boxUFCity}>
        <Select
          options={countries || []}
          defaultValue={cameraId.estado}
          label="Estado?"
          value={ufSelect}
          onChange={(e) => {
            setUfSelect(e.target.value);
            setSelectedRegion(null);
          }}
          styleOne={styles.inputTextNotMargin}
        />
        <Select
          options={city || []}
          defaultValue={cameraId.cidade}
          label="Cidade?"
          value={citySelect}
          onChange={(e) => setCitySelect(e.target.value)}
          styleOne={styles.inputTextNotMargin}
        />
      </div>
      <SelectOrRegister
        label="Qual área?"
        titleInput="Selecione ou cadastre uma nova região"
        dataRegions={allRegions || []}
        ufSelected={ufSiglaSelected}
        setSelectedRegion={setSelectedRegion}
        selectedRegion={selectedRegion}
      />
      <div className={styles.inputText}>
        <label>Nome do estabelecimento parceiro?</label>
        <input
          onChange={(e) => setEstablishment(e.target.value)}
          value={establishment}
          name="establishmentName"
        />
      </div>
      <div className={styles.inputText}>
        <label>Link do estabelecimento parceiro?</label>
        <input
          onChange={(e) => setEstablishmentLink(e.target.value)}
          value={establishmentLink}
          name="establishmentLink"
        />
      </div>
      <Select
        options={mockApiData.prediction}
        defaultValue={cameraId?.previsao_metereologica}
        label="Que previsão vai ficar?"
        value={selectPrediction}
        onChange={(e) => setSelectPrediction(e.target.value)}
      />
      <div className={styles.inputText}>
        <label>Embed Monuv?</label>
        <input
          onChange={(e) => setEmbedMonuv(e.target.value)}
          value={embedMonuv}
          name="embedMonuv"
        />
      </div>
      <div
        className={styles.inputText}
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        <Checkbox
          checked={!!stsPraia}
          onChange={(e) => {
            setStsPraia(e.target.checked);
          }}
          tabIndex={-1}
          disableRipple
        />
        <label>Praia aberta?</label>
      </div>
      <div className={styles.inputText}>
        <label>Referência</label>
        <input
          onChange={(e) => setReferency(e.target.value)}
          value={referency}
          name="referency"
          disabled
        />
      </div>
      <div className={styles.inputText}>
        <label>Descrição</label>
        <input
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          name="description"
        />
      </div>
      <SpotInformation value={spotInfo} onChange={setSpotInfo} />
      <div className={styles.boxBTNSubmit}>
        <span onClick={() => handlerSubmitUpdateCam()}>Salvar</span>
      </div>
    </div>
  );
}
